<template>
    <div class="offcanvas-menu offcanvas-menu--active">
        <div class="offcanvas-menu__overlay" @click="overlayClicked"></div>
        <transition name="menu-slide">
            <div v-if="displayMenu" class="offcanvas-menu__content">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            displayMenu: false
        }
    },
    methods: {
        close() {
            this.displayMenu = false;
        },
        overlayClicked() {
            this.close();
            this.$emit('overlay-clicked');
        },
    },
    mounted() {
        this.$store.commit('hideAllModals');
        this.displayMenu = true;
        this.waitForAds().then(() => {
            this.hideAds();
        });
        this.$on('close', function(){
            this.close();
        });

        // Prevent scrolling of the background when the menu is open
        document.body.classList.add('disable-vertical-scroll');
    },
    beforeDestroy() {
        this.unhideAds();
        this.$store.commit('unHideAllModals');
        this.$off('close');

        // Re-enable scrolling of the background
        document.body.classList.remove('disable-vertical-scroll');
    },
}
</script>

<style scoped>
.offcanvas-menu {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    z-index: 2147483550;
    overflow-x: hidden;
}

@supports (--test: 100dvh) {
    .offcanvas-menu {
        height: 100dvh;
    }
}

.offcanvas-menu--active {
    transform: translateX(0);
}

.offcanvas-menu__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.offcanvas-menu__content {
    position: fixed;
    top: 0;
    right: 0;
    width: min(500px, 100%);
    height: 100%;
    background-color: white;
    z-index: 2147483551;
}

.menu-slide-enter-active,
.menu-slide-leave-active {
    transition: transform ease 0.45s;
}
.menu-slide-enter {
    transform: translateX(100%);
}
.menu-slide-leave-to {
    transform: translateX(100%);
}
</style>
